var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 19,
    viewBox: "0 0 34 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.46877 6C4.46877 2.68629 7.15506 0 10.4688 0H24.153C26.0649 0 27.7679 0.894228 28.8666 2.28725L26.9179 3.10943C26.1996 2.42218 25.2256 2 24.153 2H10.4688C8.25963 2 6.46877 3.79086 6.46877 6V6.14062H19.7333L14.9928 8.14062H6.46877V11.737L4.46877 12.5808V6ZM0.330342 16.4975C0.0235911 16.7741 -0.0907258 17.2245 0.0780751 17.627C0.291671 18.1363 0.877701 18.3761 1.38701 18.1625L5.72633 16.3426C6.82398 17.7567 8.5401 18.6667 10.4688 18.6667H24.153C27.4667 18.6667 30.153 15.9804 30.153 12.6667V6.09847L33.3553 4.75548C33.8646 4.54189 34.1043 3.95586 33.8907 3.44655C33.6771 2.93724 33.0911 2.69752 32.5818 2.91111L29.8336 4.06363C29.8323 4.05965 29.8309 4.05567 29.8296 4.0517L27.9798 4.83212C27.9806 4.83478 27.9814 4.83744 27.9822 4.84009L24.8812 6.14062H24.8784L0.330342 16.4975ZM10.4688 16.6667C9.3803 16.6667 8.39337 16.2319 7.67217 15.5266L8.92205 15.0024C8.94042 15.0034 8.95893 15.0039 8.97755 15.0039H12.4863C13.0386 15.0039 13.4863 14.5562 13.4863 14.0039C13.4863 13.6964 13.3476 13.4214 13.1293 13.238L25.2836 8.14062H28.153V12.6667C28.153 14.8758 26.3621 16.6667 24.153 16.6667H10.4688Z",
    fill: "#DB3939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCard);
export default __webpack_public_path__ + "static/media/redCard.f345e34805a9bbbeab72b8393bd60a9d.svg";
export { ForwardRef as ReactComponent };